import { colors } from 'design-system';
import VectorIcon from './VectorIcon';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const BriefcaseIcon = ({
  width = 24,
  height = 24,
  color = colors.madison,
}: Props): JSX.Element => {
  return (
    <VectorIcon width={width} height={height}>
      <g xmlns="http://www.w3.org/2000/svg" clipPath="url(#clip0_12567_46274)">
        <path
          d="M20.9124 6.65918H15.8986V3.28418C15.8986 2.66262 
            15.4178 2.15918 14.8242 2.15918H8.37799C7.7844 2.15918 7.30361 2.66262 7.30361
             3.28418V6.65918H2.28986C1.10313 6.65918 0.141113 7.66652 0.141113 8.90918V20.9092C0.141113 
             22.1518 1.10313 23.1592 2.28986 23.1592H20.9124C22.0991 23.1592 23.0611 22.1518 
             23.0611 20.9092V8.90918C23.0611 7.66652 22.0991 6.65918 20.9124 6.65918ZM8.73611 
             3.65918H14.4661V6.65918H8.73611V3.65918ZM21.6286 20.9092C21.6286 21.3226 21.3072 
             21.6592 20.9124 21.6592H2.28986C1.89503 21.6592 1.57361 21.3226 1.57361 
             20.9092V14.1592H8.73611V16.0342C8.73611 16.6553 9.21734 17.1592 9.81049 
             17.1592H13.3917C13.9849 17.1592 14.4661 16.6553 14.4661 
             16.0342V14.1592H21.6286V20.9092ZM10.1686 15.6592V14.1592H13.0336V15.6592H10.1686ZM21.6286
              12.6592H1.57361V8.90918C1.57361 8.49574 1.89503 8.15918 2.28986 8.15918H20.9124C21.3072 
              8.15918 21.6286 8.49574 21.6286 8.90918V12.6592Z"
          fill={color}
        />
      </g>
      <defs xmlns="http://www.w3.org/2000/svg">
        <clipPath id="clip0_12567_46274">
          <rect
            width="22.92"
            height="24"
            fill="white"
            transform="translate(0.141113 0.65918)"
          />
        </clipPath>
      </defs>
    </VectorIcon>
  );
};

export default BriefcaseIcon;
